/**
 * ============================================================
 * CDS — Reconciliation cadeau automatique (paliers de livraison)
 * Studio  : Chlo' Design Studio
 * Version : 1.0
 * Desc.   : Ajoute/retire automatiquement les produits cadeaux
 *           des paliers 2/3 (snippets/cds-shipping-bar.liquid)
 *           selon le total eligible du panier (hors lignes
 *           cadeau elles-memes). Chargee sur toutes les pages
 *           via le header group (snippets/header-actions.liquid).
 *           Lit sa config depuis <script data-cds-gift-config>,
 *           emis une seule fois par le snippet cds-shipping-bar
 *           en contexte drawer (absent si le drawer ne rend pas
 *           sur la page courante : cart_type = page, ou page
 *           /cart elle-meme quand cart_type = drawer — la barre
 *           historique n'a jamais ete affichee dans ces cas-la
 *           non plus). La config est relue a chaque reconciliation
 *           (pas mise en cache) : elle peut apparaitre apres coup
 *           si le drawer se re-rend (panier initialement vide).
 * ============================================================
 */
(function () {
  'use strict';
  if (window.CDSGiftTiers) return;

  var inFlight = false;
  var pendingRerun = false;
  var paused = {};
  var pausedFingerprint = null;

  function getTiers() {
    var el = document.querySelector('[data-cds-gift-config]');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function fingerprint(cart) {
    var parts = [cart.item_count, cart.total_price];
    (cart.items || []).forEach(function (it) {
      parts.push(it.key + ':' + it.quantity);
    });
    return parts.join('|');
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  /* Dispatch cart:update matching Horizon's CartAddEvent structure (Event, pas CustomEvent,
     detail assigne en propriete directe) — meme pattern que assets/cds-product-page.js. */
  function dispatchCartUpdate(sections, itemCount) {
    var evt = new Event('cart:update', { bubbles: true });
    evt.detail = {
      resource: {},
      sourceId: 'cds-gift-tiers',
      data: {
        source: 'cds-gift-tiers',
        productId: null,
        itemCount: itemCount,
        sections: sections || {}
      }
    };
    document.dispatchEvent(evt);
  }

  function doAdd(tier, fp, currentItemCount) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: tier.variantId,
        quantity: 1,
        properties: { _cds_gift: '1' },
        sections: cartSectionIds().join(',')
      })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw { message: 'add failed' }; });
        return r.json();
      })
      .then(function (d) {
        inFlight = false;
        /* /cart/add.js ne renvoie pas item_count (juste la ligne ajoutee) : re-fetch /cart.js
           pour le compte reel du panier, meme pattern que assets/cds-product-page.js l.~797-801.
           Repli sur le compte du reconcile + 1 si ce re-fetch echoue (corrige au reconcile suivant). */
        fetch('/cart.js')
          .then(function (r2) { return r2.json(); })
          .then(function (c) { dispatchCartUpdate(d.sections, c.item_count); })
          .catch(function () { dispatchCartUpdate(d.sections, currentItemCount + 1); });
      })
      .catch(function (err) {
        /* Rupture apparue en cours de session (ou erreur reseau) : silencieux cote cliente,
           le palier est mis en pause jusqu'au prochain vrai changement de panier. */
        console.warn('CDS gift-tiers: ajout impossible pour le palier', tier.amount, err);
        paused[String(tier.variantId)] = true;
        pausedFingerprint = fp;
        inFlight = false;
        if (pendingRerun) { pendingRerun = false; reconcile(); }
      });
  }

  function doChange(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: cartSectionIds().join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        inFlight = false;
        dispatchCartUpdate(d.sections, d.item_count);
      })
      .catch(function (err) {
        console.warn('CDS gift-tiers: mise a jour de ligne impossible', err);
        inFlight = false;
        if (pendingRerun) { pendingRerun = false; reconcile(); }
      });
  }

  function reconcile() {
    var tiers = getTiers();
    if (!tiers.length) return;
    if (inFlight) { pendingRerun = true; return; }
    inFlight = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fp = fingerprint(cart);
        /* Un vrai changement de panier depuis la derniere pause leve toutes les pauses. */
        if (fp !== pausedFingerprint) paused = {};

        var deduction = 0;
        var giftLines = {};
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties._cds_gift) {
            deduction += it.final_line_price;
            giftLines[String(it.variant_id)] = it;
          }
        });
        var eligible = cart.total_price - deduction;
        if (eligible < 0) eligible = 0;

        var toAdd = null;
        var toRemove = null;
        var toFix = null;

        for (var i = 0; i < tiers.length; i++) {
          var t = tiers[i];
          var vid = String(t.variantId);
          var line = giftLines[vid];
          var reached = eligible >= t.amount;
          if (reached && !line && !paused[vid]) { toAdd = t; break; }
          if (!reached && line) { toRemove = line; break; }
          if (reached && line && line.quantity > 1) { toFix = line; break; }
        }

        if (toAdd) {
          doAdd(toAdd, fp, cart.item_count);
        } else if (toRemove) {
          doChange(toRemove.key, 0);
        } else if (toFix) {
          doChange(toFix.key, 1);
        } else {
          /* Etat conforme : zero action, la boucle s'arrete ici. */
          inFlight = false;
          if (pendingRerun) { pendingRerun = false; reconcile(); }
        }
      })
      .catch(function () {
        inFlight = false;
        if (pendingRerun) { pendingRerun = false; reconcile(); }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
  document.addEventListener('cart:update', reconcile);

  window.CDSGiftTiers = { reconcile: reconcile };
})();
